import { render, staticRenderFns } from "./ApplyForm.vue?vue&type=template&id=bb568358&scoped=true"
import script from "./ApplyForm.vue?vue&type=script&lang=js"
export * from "./ApplyForm.vue?vue&type=script&lang=js"
import style0 from "./ApplyForm.vue?vue&type=style&index=0&id=bb568358&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb568358",
  null
  
)

export default component.exports